module.exports = __webpack_public_path__ + "img/1784 (Large).9a9b0f04.jpg";